module.exports = __webpack_public_path__ + "static/media/user.41900090.png";